import React from 'react';
import { Restricted } from '../../../authentication';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, citizensTabLabel, citizensTabPathName } from '../admin-area-pathnames';
import { useTenantAddons, TenantAddonConstants } from '../../../components/tenant-addons';
import {
  absenceTypesListPathName,
  journalNoteContentTypeListPathName,
  personGroupPathName,
  reasonForReadWriteMathTestPathName,
  planTypesListPathName,
  grantTypesListPathName,
  interviewTypesListPathName,
  methodTypesListPathName,
  observationTypesListPathName,
  visitationTeamsListPathName,
} from './citizens-pathnames';
import { useFeatureToggles } from '../../../feature-toggles';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';

export function CitizensMenu() {
  const { isTenantAddonEnabled } = useTenantAddons();
  const canSeeTenantSpecificInterviewTypes = isTenantAddonEnabled(['tenantspecificinterviewtypes']);
  const canSeeTenantSpecificMethodTypes = isTenantAddonEnabled([TenantAddonConstants.SocialMyndighed]);
  const canSeeObservationTypes = isTenantAddonEnabled([TenantAddonConstants.SocialUdfoerer]);
  const { isFeatureEnabled } = useFeatureToggles();
  const canSeeVisitationTeams = isFeatureEnabled('EnableVisitationTeams');
  return (
    <Restricted actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, citizensTabPathName)}>{citizensTabLabel}</AdminHeaderLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, reasonForReadWriteMathTestPathName)}>Begrundelser for læse- skrive- regnetest</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, grantTypesListPathName)}>Bevillingstyper</AdminRouterLink>
      {canSeeVisitationTeams && <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, visitationTeamsListPathName)}>Visitationsteams</AdminRouterLink>}
      <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, absenceTypesListPathName)}>Fraværstyper</AdminRouterLink>
      {canSeeTenantSpecificMethodTypes && <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, methodTypesListPathName)}>Metoder</AdminRouterLink>}
      <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, journalNoteContentTypeListPathName)}>Notattyper</AdminRouterLink>
      {canSeeObservationTypes && <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, observationTypesListPathName)}>Observationstyper</AdminRouterLink>}
      <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, personGroupPathName)}>Persongrupper</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, planTypesListPathName)}>Plantyper</AdminRouterLink>
      {canSeeTenantSpecificInterviewTypes && <AdminRouterLink to={joinURL('/', adminAreaPathName, citizensTabPathName, interviewTypesListPathName)}>Samtaletyper</AdminRouterLink>}
    </Restricted>
  );
}
